import { DocumentNode } from 'graphql';

import { ACCOUNT_BASE_FRAGMENT } from 'graphql/fragments/account-base';
import { ACCOUNT_BASIC_FRAGMENT } from 'graphql/fragments/account-basic';
import { ACCOUNT_BRANCHES_FRAGMENT } from 'graphql/fragments/account-branches';
import { ACCOUNT_PROFILE_FRAGMENT } from 'graphql/fragments/account-profile';
import { ACCOUNT_PROFILE_IMAGE_FRAGMENT } from 'graphql/fragments/account-profile-image';
import { ARTICLE_FRAGMENT } from 'graphql/fragments/article';
import { ARTICLE_BASE_FRAGMENT } from 'graphql/fragments/article-base';
import {
  BRANCH_FRAGMENT, BRANCH_OFFER_SETTINGS_FRAGMENT, BRANCH_OFFER_TEMPLATE_SETTINGS_FRAGMENT
} from 'graphql/fragments/branch';
import { BRANCH_BASE_FRAGMENT } from 'graphql/fragments/branch-base';
import { BRANCH_IMAGE_FRAGMENT } from 'graphql/fragments/branch-image';
import { CATEGORY_FRAGMENT } from 'graphql/fragments/category';
import { CONTACT_PERSON_FRAGMENT } from 'graphql/fragments/contact-person';
import { CONTACT_PERSON_BASE_FRAGMENT } from 'graphql/fragments/contact-person-base';
import { CUSTOMER_FRAGMENT } from 'graphql/fragments/customer';
import { CUSTOMER_BASE_FRAGMENT } from 'graphql/fragments/customer-base';
import { CUSTOMER_WITH_CONDITIONS_FRAGMENT } from 'graphql/fragments/customer-with-conditions';
import { CUSTOMER_WITHOUT_CONDITIONS_FRAGMENT } from 'graphql/fragments/customer-without-conditions';
import { OBJECT_FRAGMENT } from 'graphql/fragments/object';
import { OBJECT_BASE_FRAGMENT } from 'graphql/fragments/object-base';
import { OFFER_BASE_FRAGMENT } from 'graphql/fragments/offer-base';
import { OFFER_PREVIEW_FRAGMENT } from 'graphql/fragments/offer-preview';
import { OFFER_SETTINGS_FRAGMENT } from 'graphql/fragments/offer-settings';
import { OFFER_TEMPLATE_SETTINGS_FRAGMENT } from 'graphql/fragments/offer-template-settings';
import { TEMPLATE_FRAGMENT } from 'graphql/fragments/template';
import { TEMPLATE_BASE_FRAGMENT } from 'graphql/fragments/template-base';
import { ORGANIZATION_BASE_FRAGMENT } from './organization-base';

export const fragments: Record<string, DocumentNode> = {
  OBJECT_BASE_FRAGMENT,
  OBJECT_FRAGMENT,
  CUSTOMER_BASE_FRAGMENT,
  CUSTOMER_FRAGMENT,
  CUSTOMER_WITH_CONDITIONS_FRAGMENT,
  CUSTOMER_WITHOUT_CONDITIONS_FRAGMENT,
  CONTACT_PERSON_BASE_FRAGMENT,
  CONTACT_PERSON_FRAGMENT,
  ARTICLE_BASE_FRAGMENT,
  ARTICLE_FRAGMENT,
  CATEGORY_FRAGMENT,
  TEMPLATE_BASE_FRAGMENT,
  TEMPLATE_FRAGMENT,
  ORGANIZATION_BASE_FRAGMENT,
  BRANCH_FRAGMENT,
  BRANCH_BASE_FRAGMENT,
  BRANCH_IMAGE_FRAGMENT,
  BRANCH_OFFER_SETTINGS_FRAGMENT,
  BRANCH_OFFER_TEMPLATE_SETTINGS_FRAGMENT,
  ACCOUNT_PROFILE_FRAGMENT,
  ACCOUNT_PROFILE_IMAGE_FRAGMENT,
  ACCOUNT_BASE_FRAGMENT,
  ACCOUNT_BASIC_FRAGMENT,
  ACCOUNT_BRANCHES_FRAGMENT,
  OFFER_SETTINGS_FRAGMENT,
  OFFER_TEMPLATE_SETTINGS_FRAGMENT,
  OFFER_PREVIEW_FRAGMENT,
  OFFER_BASE_FRAGMENT
};
